// extracted by mini-css-extract-plugin
export var border = "_2d-8";
export var brand = "_2d-t";
export var button = "_2d-l";
export var center = "_2d-a";
export var centered = "_2d-6";
export var closeButton = "_2d-c";
export var disabledWrapper = "_2d-m";
export var error = "_2d-p";
export var extraLarge = "_2d-4";
export var extraSmall = "_2d-1";
export var fill = "_2d-i";
export var footer = "_2d-h";
export var footerAction = "_2d-j";
export var footerButtons = "_2d-k";
export var header = "_2d-7";
export var headerWithClose = "_2d-d";
export var icon = "_2d-o";
export var info = "_2d-s";
export var inline = "_2d-9";
export var large = "_2d-3";
export var main = "_2d-e";
export var modal = "_2d-0";
export var nearFull = "_2d-5";
export var neutral = "_2d-u";
export var noPadding = "_2d-g";
export var none = "_2d-v";
export var scrollable = "_2d-f";
export var small = "_2d-2";
export var success = "_2d-r";
export var tight = "_2d-n";
export var titleIcon = "_2d-b";
export var warn = "_2d-q";